import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import cuidadorasImg from '../../assets/cuidadoras.jpg';

const EnfermeriaTlaquepaque = () => {
  const pageData = {
    title: "Enfermería a Domicilio en Tlaquepaque",
    metaDescription: "Servicio de enfermería a domicilio en Tlaquepaque. Cuidado profesional para adultos mayores y pacientes. Atención en todas las colonias.",
    heroTitle: "Enfermería a Domicilio en Tlaquepaque",
    heroSubtitle: "Atención médica de calidad en todo San Pedro Tlaquepaque",
    description: "Llevamos servicios profesionales de enfermería a todas las colonias de Tlaquepaque. Desde el Centro Histórico hasta Las Juntas, nuestro personal certificado está listo para brindarte la atención que tu familia necesita sin salir de casa.",
    benefits: [
      "Cobertura total en Tlaquepaque",
      "Servicio en zonas residenciales y populares",
      "Personal con experiencia en la zona",
      "Disponibilidad 24 horas",
      "Precios accesibles",
      "Sin cargos extra por distancia",
      "Coordinación con hospitales locales",
      "Atención cultural y respetuosa"
    ],
    features: [
      {
        title: "Centro Histórico",
        description: "Servicio en el Centro, El Parián y colonias tradicionales"
      },
      {
        title: "Las Juntas",
        description: "Cobertura en Las Juntas, La Duraznera y zonas aledañas"
      },
      {
        title: "Santa Anita",
        description: "Atención en Santa Anita, La Capacha y colonias cercanas"
      },
      {
        title: "Zona Industrial",
        description: "Servicio cerca de zonas industriales y comerciales"
      },
      {
        title: "Fraccionamientos",
        description: "Cobertura en fraccionamientos nuevos y establecidos"
      },
      {
        title: "Hospitales Cercanos",
        description: "Coordinación con hospitales y clínicas de la zona"
      }
    ],
    faqs: [
      {
        question: "¿Atienden en todo Tlaquepaque?",
        answer: "Sí, cubrimos todo el municipio de San Pedro Tlaquepaque, incluyendo el Centro Histórico, Las Juntas, Santa Anita, y todas las demás colonias."
      },
      {
        question: "¿Hay cobro extra por ir a Tlaquepaque?",
        answer: "No, nuestras tarifas son las mismas para toda el área metropolitana de Guadalajara, sin cargos adicionales por zona."
      },
      {
        question: "¿Tienen personal disponible de inmediato?",
        answer: "Contamos con personal en diferentes zonas. Para servicios urgentes, podemos coordinar atención en 1-2 horas según disponibilidad."
      },
      {
        question: "¿Se coordinan con el Hospital General de Tlaquepaque?",
        answer: "Sí, trabajamos en coordinación con todos los hospitales y clínicas de la zona para dar continuidad a los tratamientos."
      }
    ],
    image: cuidadorasImg,
    relatedBlogSlugs: ['enfermeria-domicilio-guadalajara-2026', 'como-elegir-enfermera-domicilio']
  };

  return <ServiceLandingPage {...pageData} />;
};

export default EnfermeriaTlaquepaque;
